function axisExec (target, field, axis) { //FIXME: 실제 그려야할 Axis object 저장하는데 이름을 target-field로 계속 진행해야할지 단일한 계열로 바꿔야 할지 고민
  if(!arguments.length) return this.__execs__.axis;
  this.__execs__.axis[target] = this.__execs__.axis[target] || {}
  this.__execs__.axis[target][field] = axis; //axis.x.field 형태
  return this;
}

export default axisExec;


// WEBPACK FOOTER //
// ./layouts/rectLinear/axisExec.js